import { ReactNode } from "react";

export default function CardComponent({ children }: { children: ReactNode }) {
  return (
    <div className="flex items-center overflow-hidden rounded-lg bg-white px-4 py-5 shadow-2xl sm:px-6 sm:pt-6">
      {children}
    </div>
  );
}
